function Notice() {
    return (
      
      <section className="Notice">
        <h1>I am Notice</h1>
      </section>
    );
  }
  
  export default Notice;